import { mainUrl } from "../../utils/variant";
import React from "react";
import { useLocation } from 'react-router-dom';
import { useVariantCopy } from './useVariantCopy';
import DeferredVideo from '../DeferredVideo';

// Variant landing-page testimonials (startviralgpt.com). Clone of
// components/Testimonials.js. All links here are external (Instagram profiles)
// or in-page anchors (#pricing), so nothing needs rewiring to the main site.
const Testimonials = () => {
  const L = useVariantCopy();
  const location = useLocation();
  const isRegisterPage = location.pathname === '/register';

  const reviews = [
    {
      name: "Daniel",
      username: "daniel_slovak",
      platform: "instagram",
      link: "https://www.instagram.com/daniel_slovak/",
      image: "https://i.imgur.com/mQyhndN.jpeg",
      growth: "10k → 40k",
      stars: 5,
    },
    {
      name: "Smoke",
      username: "smoke",
      platform: "instagram",
      link: "https://www.instagram.com/smoke/",
      image: "https://i.imgur.com/kFw388B.jpeg",
      growth: "180k → 359k",
      stars: 5,
    },
    {
      name: "Vikky",
      username: "vikky",
      platform: "instagram",
      link: "https://www.instagram.com/vikky/",
      image: "https://i.imgur.com/bLEES7L.jpeg",
      growth: "800 → 2.5k",
      stars: 5,
    },
  ];

  // before/after are the same figures already quoted in the reviews above
  // (e.g. daniel_slovak 10k -> 40k), derived from followers minus growth.
  const profiles = [
    { href: "https://instagram.com/gr.tomek", img: "https://i.imgur.com/7mB7Ssd.jpeg", name: "@gr.tomek", before: "1.2k", after: "4k", growth: "+2.8k", verified: true },
    { href: "https://instagram.com/toyotasupra", img: "https://i.imgur.com/kVWy4sC.jpeg", name: "@toyotasupra", before: "1.3k", after: "3.2k", growth: "+1.9k" },
    { href: "https://instagram.com/daniel_slovak", img: "https://i.imgur.com/mQyhndN.jpeg", name: "@daniel_slovak", before: "10k", after: "40k", growth: "+30k" },
    { href: "https://instagram.com/vikky", img: "https://i.imgur.com/bLEES7L.jpeg", name: "@vikky", before: "800", after: "2.5k", growth: "+1.7k" },
  ];

  return (
    <>
      <section id="testimonials" style={{ paddingTop: '4rem', paddingBottom: '4rem', background: '#fff' }}>
        <div className="mx-auto px-4 stripe-container" style={{ maxWidth: '1100px' }}>

          {/* Section Header */}
          <div className="text-center" style={{ marginBottom: '3rem' }}>
            <div className="d-inline-flex align-items-center gap-2 px-3 py-2 mb-3" style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '100px' }}>
              <i className="fa-solid fa-shield-check" style={{ color: '#16a34a', fontSize: '0.8rem' }}></i>
              <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#16a34a', letterSpacing: '0.03em' }}>{L.testimonials.verifiedResults}</span>
            </div>
            <h2 className="stripe-heading stripe-heading--lg" style={{ maxWidth: '700px', margin: '0 auto' }}>
              {L.testimonials.heading}
            </h2>
            <p className="mt-3 mx-auto stripe-body stripe-body--md" style={{ maxWidth: '520px', color: '#64748b' }}>
              {L.testimonials.sub}
            </p>

            {/* Aggregate Rating */}
            <div className="d-inline-flex align-items-center gap-2 mt-3 px-4 py-2" style={{ background: '#fafafa', borderRadius: '16px', border: '1px solid #f0f0f0' }}>
              <div className="d-flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star" style={{ color: '#facc15', fontSize: '0.85rem' }}></i>
                ))}
              </div>
              <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0a2540' }}>4.9/5</span>
              <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{L.testimonials.fromReviews}</span>
            </div>
          </div>

          {/* Before/After follower count cards */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-4" style={{ maxWidth: '860px', margin: '0 auto' }}>
            {profiles.map((item, i) => (
              <a key={i} href={item.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', flex: '1 1 0', minWidth: '140px', maxWidth: '200px' }}>
                <div style={{
                  background: '#fff',
                  border: '1px solid #e8ecf1',
                  borderRadius: '18px',
                  padding: '1.25rem 0.75rem',
                  textAlign: 'center',
                  transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                }}
                onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseOut={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  <img src={item.img} alt={item.name} style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9', display: 'block', margin: '0 auto 0.6rem' }} />
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span style={{ fontWeight: 600, fontSize: '0.8rem', color: '#0a2540' }}>{item.name}</span>
                    {item.verified && <img loading="lazy" alt={L.testimonials.verifiedAlt} src="https://rizzup.net/images/check.svg" width="12" height="12" />}
                  </div>

                  {/* Before -> after follower count */}
                  <div className="d-flex align-items-center justify-content-center gap-1" style={{ marginTop: '0.4rem', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '0.78rem', color: '#8898aa', textDecoration: 'line-through' }}>{item.before}</span>
                    <i className="fa-solid fa-arrow-right" style={{ fontSize: '0.6rem', color: '#94a3b8' }}></i>
                    <span style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0a2540' }}>{L.testimonials.followersCount(item.after)}</span>
                  </div>
                  <div style={{ marginTop: '0.3rem' }}>
                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#16a34a', background: '#dcfce7', padding: '2px 8px', borderRadius: '999px' }}>
                      {item.growth}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* @smoke before/after + video */}
          <div className="mb-4" style={{ maxWidth: '480px', margin: '0 auto' }}>
            <a
              href="https://instagram.com/smoke"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', display: 'block', marginBottom: '0.75rem' }}
            >
              <div style={{
                background: '#fff',
                border: '1px solid #e8ecf1',
                borderRadius: '18px',
                padding: '1.25rem 1rem',
                textAlign: 'center',
                transition: 'box-shadow 0.3s ease, transform 0.3s ease',
              }}
              onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseOut={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <img
                  src="https://i.imgur.com/kFw388B.jpeg"
                  alt="@smoke"
                  style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9', display: 'block', margin: '0 auto 0.6rem' }}
                />
                <div className="d-flex align-items-center justify-content-center gap-1">
                  <span style={{ fontWeight: 600, fontSize: '0.8rem', color: '#0a2540' }}>@smoke</span>
                  <img loading="lazy" alt={L.testimonials.verifiedAlt} src="https://rizzup.net/images/check.svg" width="12" height="12" />
                </div>
                <div className="d-flex align-items-center justify-content-center gap-1" style={{ marginTop: '0.4rem', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '0.78rem', color: '#8898aa', textDecoration: 'line-through' }}>180k</span>
                  <i className="fa-solid fa-arrow-right" style={{ fontSize: '0.6rem', color: '#94a3b8' }}></i>
                  <span style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0a2540' }}>{L.testimonials.followersCount('359k')}</span>
                </div>
                <div style={{ marginTop: '0.3rem' }}>
                  <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#16a34a', background: '#dcfce7', padding: '2px 8px', borderRadius: '999px' }}>
                    +179k
                  </span>
                </div>
              </div>
            </a>

            <div style={{
              background: '#fff',
              border: '1px solid #e8ecf1',
              borderRadius: '20px',
              padding: '1rem',
            }}>
              <DeferredVideo
                src="https://i.imgur.com/fIKySBd.mp4"
                poster="https://i.imgur.com/fIKySBd.png"
                ariaLabel="Play customer testimonial"
              />
              <a href="https://instagram.com/smoke" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div className="d-flex align-items-center gap-3 mt-3 px-1">
                  <img src="https://i.imgur.com/kFw388B.jpeg" alt="Smoke" style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9' }} />
                  <div className="text-start" style={{ flex: 1 }}>
                    <div className="d-flex align-items-center gap-1">
                      <span style={{ fontWeight: 600, fontSize: '0.85rem', color: '#0a2540' }}>@smoke</span>
                      <img loading="lazy" alt={L.testimonials.verifiedAlt} src="https://rizzup.net/images/check.svg" width="14" height="14" />
                    </div>
                    <div style={{ fontSize: '0.73rem', color: '#94a3b8' }}>{L.testimonials.smokeTitle}</div>
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* Written testimonials */}
          <div className="row justify-content-center" style={{ gap: '0' }}>
            {reviews.map((review, index) => (
              <div key={index} className="col-12 col-md-4 mb-4">
                <div style={{
                  background: '#fff',
                  border: '1px solid #e8ecf1',
                  borderRadius: '16px',
                  padding: '2rem 1.75rem',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                  cursor: 'default',
                }}
                onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseOut={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  {/* Stars */}
                  <div className="d-flex gap-1 mb-3">
                    {[...Array(review.stars)].map((_, i) => (
                      <i key={i} className="fa-solid fa-star" style={{ color: '#facc15', fontSize: '0.8rem' }}></i>
                    ))}
                  </div>

                  {/* Quote */}
                  <p style={{ fontSize: '0.95rem', lineHeight: 1.7, color: '#334155', flex: 1, margin: 0 }}>
                    "{L.testimonials.reviews[review.username]}"
                  </p>

                  {/* Divider */}
                  <div style={{ height: '1px', background: '#f1f5f9', margin: '1.25rem 0' }}></div>

                  {/* Author */}
                  <div className="d-flex align-items-center gap-3">
                    <a href={review.link} target="_blank" rel="noopener noreferrer">
                      <img
                        src={review.image}
                        alt={review.name}
                        style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9' }}
                      />
                    </a>
                    <div style={{ flex: 1 }}>
                      <div className="d-flex align-items-center gap-1">
                        <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#0a2540' }}>{review.name}</span>
                        <i className="fa-solid fa-circle-check" style={{ color: '#3b82f6', fontSize: '0.75rem' }}></i>
                      </div>
                      <a href={review.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', fontSize: '0.8rem', color: '#94a3b8' }}>
                        <i className="fab fa-instagram text-instagram" style={{ fontSize: '0.75rem', marginRight: '3px' }}></i>
                        @{review.username}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          {!isRegisterPage && (
            <div className="text-center mt-5">
              <a
                href={mainUrl("/pricing")}
                className="group inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-semibold text-white rounded-xl bg-instagram transition-all duration-200 hover:scale-105 text-decoration-none"
                style={{ boxShadow: '0 4px 14px 0 rgba(225, 48, 108, 0.3)' }}
              >
                {L.testimonials.ctaButton}
                <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1"></i>
              </a>
              <p className="mt-3" style={{ fontSize: '0.8rem', color: '#94a3b8' }}>
                {L.testimonials.ctaSub}
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Testimonials;
